import { Link } from '@tiptap/extension-link';
import { Placeholder } from '@tiptap/extension-placeholder';
import { StarterKit } from '@tiptap/starter-kit';
import { LinkBubbleMenuHandler } from 'mui-tiptap';
export function createDefaultExtensions(options = {}) {
    const { placeholder } = options;
    return [
        StarterKit.configure({
            codeBlock: false,
            link: false,
        }),
        Link.configure({
            openOnClick: false,
            autolink: true,
            linkOnPaste: true,
            HTMLAttributes: {
                target: '_blank',
                rel: 'noopener noreferrer',
            },
        }),
        LinkBubbleMenuHandler,
        Placeholder.configure({
            placeholder: placeholder ?? 'No content',
        }),
    ];
}
//# sourceMappingURL=defaultExtensions.js.map